import { motion } from "framer-motion";
import { Youtube } from "lucide-react";
import { toast } from "sonner";
import { LogoLockup } from "./Logo";
import { MiniCountdown } from "./CountdownBlocks";
import { SUBSCRIBE_URL, CHANNEL_HANDLE } from "@/constants/campaign";

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-slate-200/70 bg-[#FFFFFF]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
        <LogoLockup />
        <div className="flex items-center gap-3">
          <MiniCountdown />
          <a
            data-testid="nav-claim-cta"
            href={SUBSCRIBE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => toast.success(`Opening ${CHANNEL_HANDLE} on YouTube…`)}
            className="hidden items-center gap-2 rounded-xl bg-gradient-to-r from-red-500 via-red-500 to-red-600 px-5 py-2.5 text-sm font-black tracking-wide text-white shadow-[0_0_25px_rgba(255,0,0,0.4)] transition-all duration-200 hover:scale-[1.03] hover:shadow-[0_0_40px_rgba(255,0,0,0.6)] active:scale-[0.98] sm:flex"
          >
            <Youtube className="h-4 w-4" />
            Subscribe & Claim $500
          </a>
        </div>
      </div>
    </motion.header>
  );
}
